module.exports = __webpack_public_path__ + "img/index-solutions-platform.77bfd0a7.png";